import { AutomotivePageTemplate } from "./AutomotivePageTemplate";

const GtaDealers = () => {
  return <AutomotivePageTemplate variant="gtaDealers" />;
};

export default GtaDealers;
